import { useRef } from "react";
import {
  FormControl,
  Select,
  VStack,
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
} from "@chakra-ui/react";
import { HiFilter } from "react-icons/hi";
export function Filter({ children }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();
  return (
    <>
      <Button
        // mb={[1, 2, 4]}
        fontSize={[16, 18, 20]}
        ref={btnRef}
        colorScheme="blue"
        onClick={onOpen}
        leftIcon={<HiFilter />}
        aria-label="Fliter"
      >
        Filter
      </Button>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size="md"
      >
        <DrawerOverlay>
          <DrawerContent>
            <DrawerHeader>Create your account</DrawerHeader>
            
            <DrawerBody>
              <FormControl id="Filter" p={1} w="auto">
                <VStack align="center" justify="center" spacing={2}>
                  <Select
                    placeholder="University"
                    size={"md"}
                    borderColor="teal.300"
                  >
                    <option value="option1">Option 1</option>
                  </Select>
                  <Select placeholder="Major" size="md" borderColor="teal.300">
                    <option value="option1">Option 1</option>
                  </Select>
                  <Select placeholder="Course" size="md" borderColor="teal.300">
                    <option value="{ children }">{children}</option>
                  </Select>
                  <Select
                    placeholder="File type"
                    size="md"
                    borderColor="teal.300"
                  >
                    <option value="img">Image</option>
                    <option value="pdf">PDF</option>
                    <option value="docx">Word</option>
                    <option value="pptx">Powerpoint</option>
                    <option value="xlsx">Excel</option>
                  </Select>
                </VStack>
              </FormControl>
            </DrawerBody>

            <DrawerFooter>
              <Button
                variant="outline"
                me={3}
                onClick={onClose}
                aria-label="close"
              >
                Close
              </Button>
              <Button aria-label="Save">Save</Button>
            </DrawerFooter>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </>
  );
}
